export default function scoller () {

	const links = document.querySelector('.sub-menu > .links')
	if (!links) {
		console.log('.sub-menu > .links not found')
		return
	}
	const linksStyle = window.getComputedStyle(links, null)

	const scrollHorizontally = (e) => {
		// check if is desktop layout
		if (linksStyle.position != 'absolute') {
			e = window.event || e
			e.preventDefault()
			links.scrollLeft -= (e.wheelDelta || -e.detail)	
		}
	}

	if (links.addEventListener) {
		links.addEventListener('mousewheel', scrollHorizontally, false)
		links.addEventListener('DOMMouseScroll', scrollHorizontally, false)
	} else {
		links.attachEvent('onmousewheel', scrollHorizontally)
	}
}



// WEBPACK FOOTER //
// ./src/utils/scroller.js